import { render, staticRenderFns } from "./AutomationPanel.vue?vue&type=template&id=3befa050&scoped=true"
import script from "./AutomationPanel.vue?vue&type=script&lang=js"
export * from "./AutomationPanel.vue?vue&type=script&lang=js"
import style0 from "./AutomationPanel.vue?vue&type=style&index=0&id=3befa050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3befa050",
  null
  
)

export default component.exports